import { render, staticRenderFns } from "./UserAdmin.vue?vue&type=template&id=234a3df0&scoped=true&"
import script from "./UserAdmin.vue?vue&type=script&lang=js&"
export * from "./UserAdmin.vue?vue&type=script&lang=js&"
import style0 from "./UserAdmin.vue?vue&type=style&index=0&id=234a3df0&scoped=true&lang=css&"
import style1 from "./UserAdmin.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "234a3df0",
  null
  
)

export default component.exports